import type { Pagination } from "src/types/common"
import type { AppConfig, AppConfigRule } from "src/types/app"

import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"


interface ConfigState {
    currentConfig: AppConfig | null,
    configs: Pagination<AppConfig> | null,
    configRules: AppConfigRule | null,
    draft: Record<string, any> | null,
}

const initialUserState = {
  currentConfig: null,
  configs: null,
  configRules: null,
  draft: null
}

type Actions = {
  reset: () => void
}

export const configModel = create(
  persist<ConfigState & Actions>(
    set => ({
      ...initialUserState,
      reset: () => {
        set(initialUserState)
      },
    }),
    {
      name: "sc-config-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
)